<template>
  <div class="box-login">
    <form @submit="login">
      <div class="login">
        <b-container class="text-left" style="margin: auto;">
          <b-row class="justify-content-center">
            <b-col style="background: black;" lg="5" md="7" sm="10" cols="10">
              <h4 style="color:#fff" class="text">เข้าสู่ระบบ</h4>
            </b-col>
          </b-row>
          <b-row class="justify-content-center">
            <b-col class="one" lg="5" md="7" sm="10" cols="10">
              <p></p>
            </b-col>
          </b-row>
          <b-row class="justify-content-center">
            <b-col class="two" lg="5" md="7" sm="10" cols="10">
              <b-row>
                <b-col>
                  <div class="form-group">
                    <label for="exampleInputEmail1">
                      ชื่อผู้ใช้
                      <span class="required">*</span>
                    </label>
                    <input id="input1" v-model="userdadta.username" required class="form-control" />
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <div class="form-group">
                    <label>
                      รหัสผ่าน
                      <span class="required">*</span>
                    </label>
                    <input
                      id="input2"
                      v-model="userdadta.password"
                      required
                      type="password"
                      class="form-control"
                    />
                  </div>
                </b-col>
              </b-row>
              <b-row class="text-center">
                <b-col>
                  <button type="submit" class="btn btn-success btn-sm btnLogin">เข้าสู่ระบบ</button>
                </b-col>
              </b-row>
              <br />
            </b-col>
          </b-row>
          <b-row class="justify-content-center">
            <b-col class="one" lg="5" md="7" sm="10" cols="10">
              <h4 class="text"></h4>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </form>

  </div>
</template>

<script>

import axios from "axios";
export default {
  components: {},
  mounted() {
    axios.get("http://www.geoplugin.net/json.gp").then(res => {
      this.access_ipaddress = res.data.geoplugin_request;
    });
  },
  data() {
    return {
      userdadta: {
        username: "",
        password: ""
      },
      access_ipaddress: null
    };
  },
  methods: {
    login: function(e) {
      e.preventDefault();
      axios
        .post("http://165.22.250.134:8081/api/suppier/login", this.userdadta)
        .then(res => {
          if (res.data.response) {
            axios
              .post("http://165.22.250.134:8081/api/suppier/accesslog", {
                username: this.userdadta.username,
                project_log: "suppierreport"
              })
              .then(rest => {
                this.$session.set("name",this.userdadta.username)
                if(rest.data.response){
                  if(res.data.role==='admin'){
                    this.$router.push('/sandreport')
                  } else if(res.data.role==='staff'){
                    this.$router.push('/sandreport')
                  } else if(res.data.role === 'supplier'){
                    if(res.data.sand === "1"&res.data.stone === "0"){
                      this.$router.push('/sandreport')
                    }else if(res.data.sand === "0"&res.data.stone === "1"){
                      this.$router.push('/stondreport')
                    }
                  }
                }
              });
          } else {
            this.$bvToast.toast(res.data.error, {
              title: "ผิดพลาด",
              autoHideDelay: 5000,
              appendToast: true,
              variant: "danger"
            });
          }
        });
    }
  }
};
</script>

<style>
.required {
  color: red !important;
}
.box-login {
  min-height: 100%;
  width: 100%;
  position: absolute;
  background-color: rgb(231, 231, 231) !important;
}
 .login {
  font-family: "K2D";
  margin: 5% !important;
  padding-bottom: 12%;
  
}
@media (max-width: 600px) {
  .login {
    padding-bottom: 300px;
  }
}
.one {
  background-color: #ff0000;
}
.text {
  padding: 10px;
  color: rgb(221, 16, 16);
}
.two {
  padding: 10px;
  background-color: white;
}
.form-group {
  padding: 5px;
  margin-bottom: 5px !important;
}
</style>
